exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "hr{\r\n  height: 1px;\r\n  background-color: #A9A9A9;\r\n}\r\nh6{\r\n  font-weight: bold;\r\n  color: #007b85;\r\n}\r\n::ng-deep .mat-progress-bar-fill::after {\r\n    background-color: #F15D22;\r\n}\r\n\r\n::ng-deep .mat-progress-bar-buffer {\r\n    background: #E4E8EB;\r\n}\r\n\r\n::ng-deep .mat-progress-bar {\r\n    border-radius: 2px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/telco-audit-trail/enquiry-history-by-other/enquiry-history-by-other.component.css
// module id = 474
// module chunks = 1